<template>
  <div class="container">
    <section class="w1200">
      <nav>当前位置：首页 > 使用帮助</nav>
      <div class="main flex">
        <div class="main_left">
          <ul class="item">
            <li @click="handleChangeTab(1)" :class="{ checked: tabIndex == 1 }">
              外文学术资源数据库使用方法
            </li>
            <li @click="handleChangeTab(2)" :class="{ checked: tabIndex == 2 }">
              文献检索
            </li>
            <li @click="handleChangeTab(4)" :class="{ checked: tabIndex == 4 }">
              AI学术搜索
            </li>
            <li @click="handleChangeTab(6)" :class="{ checked: tabIndex == 6 }">
              学者搜索
            </li>
            <li @click="handleChangeTab(3)" :class="{ checked: tabIndex == 3 }">
              文献传递和按需单篇采选
            </li>
            <li
              @click="handleChangeTab(10)"
              :class="{ checked: tabIndex == 10 }"
            >
              学术论坛文献求助
            </li>
            <li @click="handleChangeTab(5)" :class="{ checked: tabIndex == 5 }">
              AI全文解析
            </li>
            <li @click="handleChangeTab(7)" :class="{ checked: tabIndex == 7 }">
              期刊导航
            </li>
            <li
              @click="handleChangeTab(11)"
              :class="{ checked: tabIndex == 11 }"
            >
              文献服务平台
            </li>
            <li
              @click="handleChangeTab(12)"
              :class="{ checked: tabIndex == 12 }"
            >
              学科知识库
            </li>
            <li @click="handleChangeTab(9)" :class="{ checked: tabIndex == 9 }">
              资源助手
            </li>
            <!-- <li @click="handleChangeTab(8)" :class="{ checked: tabIndex == 8 }">
              技术领域分析
            </li> -->
          </ul>
        </div>
        <div class="main_right">
          <page1 v-if="tabIndex == 1"></page1>
          <page2 v-if="tabIndex == 2"></page2>
          <page3 v-if="tabIndex == 3"></page3>
          <page4 v-if="tabIndex == 4"></page4>
          <page5 v-if="tabIndex == 5"></page5>
          <page6 v-if="tabIndex == 6"></page6>
          <page7 v-if="tabIndex == 7"></page7>
          <page8 v-if="tabIndex == 8"></page8>
          <page9 v-if="tabIndex == 9"></page9>
          <page10 v-if="tabIndex == 10"></page10>
          <page11 v-if="tabIndex == 11"></page11>
          <page12 v-if="tabIndex == 12"></page12>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Page1 from "./page1";
import Page2 from "./page2";
import Page3 from "./page3";
import Page4 from "./page4";
import Page5 from "./page5";
import Page6 from "./page6";
import Page7 from "./page7";
import Page8 from "./page8";
import Page9 from "./page9";
import Page10 from "./page10";
import Page11 from "./page11";
import Page12 from "./page12";

export default {
  name: "illustrate",
  data() {
    return {
      tabIndex: 1,
    };
  },
  components: {
    Page1,
    Page2,
    Page3,
    Page4,
    Page5,
    Page6,
    Page7,
    Page8,
    Page9,
    Page10,
    Page11,
    Page12,
  },
  mounted() {},
  methods: {
    handleChangeTab(index) {
      this.tabIndex = index;
    },
    toHome() {
      this.$router.push({ path: "/article" });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 233px);
  .w1200 {
    min-height: calc(100vh - 219px);
    padding-bottom: 30px;
    nav {
      padding: 20px 0;
      font-size: 14px;
      color: #999999;
    }
    .main {
      height: 100%;
      .main_left {
        background: rgba(21, 186, 188, 0.1);
        width: 270px;
        .item {
          padding-left: 10px;
          padding-top: 30px;
          li {
            display: flex;
            align-items: center;
            padding: 10px 0;
            padding-left: 40px;
            cursor: pointer;
            img {
              margin-right: 10px;
              width: 20px;
            }
          }
          .checked {
            background: #fff;
            color: #2d8cf0;
          }
        }
      }
      .main_right {
        flex: 1;
        min-width: 0;
        background: #fff;
      }
    }
  }
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 20px;
  }
  .dialogInfo {
    padding: 0 40px;
    .item {
      align-items: center;
      margin-bottom: 15px;
      font-size: 16px;
      &:last-of-type {
        margin: 0;
      }
      ::v-deep .el-input__inner {
        border-radius: 0;
      }
      .el-input {
        flex: 1;
        margin-left: 10px;
      }
      .phone {
        flex: 1;
        position: relative;
        .code {
          position: absolute;
          right: 0;
          height: 40px;
          line-height: 40px;
          color: #a21e1e;
          padding: 0 20px;
          cursor: pointer;
          &::after {
            content: "";
            position: absolute;
            left: 0;
            width: 1px;
            height: 20px;
            top: 10px;
            background: #cccccc;
          }
        }
      }
    }
  }
}
</style>
